import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
import * as XLSX from 'xlsx';
const TIME_ZONE = process.env.REACT_APP_TIME_ZONE;
dayjs.extend(utc);
dayjs.extend(timezone);

export const convertDateObjectToString = (localDate) => {
  if (!localDate) return null;
  const formattedLocalDate = dayjs(localDate).format('YYYY-MM-DD HH:mm:ss');
  return formattedLocalDate;
};

export function getCurrentTimeOfTimeZone() {
  const now = dayjs().tz(TIME_ZONE);
  return now.format('HH:mm:ss');
}
export const getCurrentDateWithAdjustedTime = (localDate) => {
  const selectedDateString = localDate.format('YYYY-MM-DD');
  const thisDateMoment = `${selectedDateString} ${getCurrentTimeOfTimeZone()}`;
  return thisDateMoment;
};
export const getDateByDayNumber = (dayNumber, startOfWeek = 'sunday') => {
  const today = dayjs().startOf('day'); // normalize to start of today
  const currentDay = today.day(); // 0 = Sunday, ..., 6 = Saturday

  let targetDay;

  if (startOfWeek === 'sunday') {
    // Sunday = 0, Monday = 1, ..., Saturday = 6
    targetDay = dayNumber;
  } else if (startOfWeek === 'monday') {
    // Monday = 1, Tuesday = 2, ..., Sunday = 7
    targetDay = dayNumber === 7 ? 0 : dayNumber;
  } else {
    throw new Error('startOfWeek must be either "sunday" or "monday"');
  }

  // Validate day number
  if (targetDay < 0 || targetDay > 6) {
    throw new Error('Day number must be between 0-6 for Sunday start or 1-7 for Monday start');
  }

  // Calculate difference
  let daysDifference = targetDay - currentDay;

  // If the target day is before today, move to next week
  if (daysDifference < 0) {
    daysDifference += 7;
  }

  const targetDate = today.add(daysDifference, 'day');

  return getCurrentDateWithAdjustedTime(targetDate);
};

export function getCurrentTimeZoneStamp() {
  const now = dayjs().tz(TIME_ZONE);
  return now.format('YYYY-MM-DD HH:mm:ss');
}

export const exportToExcel = (excelData, filename) => {
  const fileExtension = '.xlsx';
  const ws = XLSX.utils.json_to_sheet(excelData);
  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, filename);
  XLSX.writeFile(wb, filename + fileExtension);
};
